import { APP_VERSION } from "@/config/version";

interface VersionFooterProps {
    /** Se true, il footer è posizionato in modo fixed. Se false, è posizionato normalmente nel flusso del documento. */
    fixed?: boolean;
}

export const VersionFooter = ({ fixed = false }: VersionFooterProps) => {
    return (
        <div className={`${fixed ? 'fixed bottom-0 left-0 right-0 z-10 pointer-events-none' : ''} flex justify-center py-0`}>
            <span className="text-xs text-quaternary/60">
                v. {APP_VERSION}
            </span>
        </div>
    );
};

